// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { formatPhone } from '../utils/formatPhone'
import { emitTourEvent, TOUR_EVENT_TYPES } from '../lib/appEvents'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
  dangerBg: '#FDECEA', successBg: '#EBF5EF',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const inp = {
  width: '100%', background: C.bg, border: `1px solid ${C.border}`,
  borderRadius: '8px', padding: '9px 12px', fontSize: '16px',
  fontFamily: fs, color: C.brown, boxSizing: 'border-box', outline: 'none',
  WebkitUserSelect: 'text', userSelect: 'text', touchAction: 'manipulation',
  WebkitAppearance: 'none',
}
const lbl = {
  fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
  textTransform: 'uppercase', fontFamily: fs, display: 'block', marginBottom: '4px',
}
const subHdr = {
  fontSize: '10px', color: C.muted, letterSpacing: '2px', textTransform: 'uppercase',
  fontFamily: fs, fontWeight: '700', marginBottom: '10px', marginTop: '24px',
}

const RELATIONSHIPS = ['Spouse', 'Child', 'Parent', 'Family (Other)', 'Neighbor', 'Doctor', 'Other']

const SERVICE_CONFIG = {
  emergency:      { icon: '🚨', label: 'Emergency' },
  police:         { icon: '🚔', label: 'Police' },
  fire:           { icon: '🚒', label: 'Fire Dept.' },
  sheriff:        { icon: '🏛️', label: 'Sheriff' },
  hospital:       { icon: '🏥', label: 'Hospital' },
  poison_control: { icon: '☠️', label: 'Poison Control' },
  crisis:         { icon: '🧠', label: 'Crisis Line' },
  vet_emergency:  { icon: '🐾', label: 'Vet Emergency' },
  utility:        { icon: '🔌', label: 'Utility' },
  utility_electric: { icon: '⚡', label: 'Electric' },
  utility_gas:    { icon: '🔥', label: 'Gas' },
  utility_water:  { icon: '💧', label: 'Water' },
  doctor:         { icon: '👨‍⚕️', label: 'Doctor' },
  pharmacy:       { icon: '💊', label: 'Pharmacy' },
  locksmith:      { icon: '🔑', label: 'Locksmith' },
  plumber:        { icon: '🔧', label: 'Plumber' },
  other:          { icon: '📞', label: 'Other' },
}

function ContactCard({ contact, onEdit, onDelete, onMoveUp, onMoveDown, isFirst, isLast }) {
  const [confirmDel, setConfirmDel] = useState(false)
  return (
    <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '14px 16px', marginBottom: '8px', boxShadow: '0 1px 4px rgba(44,29,20,0.04)' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <div style={{ fontSize: '14px', fontWeight: '700', color: C.brown, fontFamily: f }}>{contact.name}</div>
            {contact.relationship && (
              <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: C.bg, border: `1px solid ${C.border}`, color: C.muted, fontFamily: fs }}>{contact.relationship}</span>
            )}
          </div>
          {contact.phone && <div style={{ fontSize: '13px', color: C.brown, fontFamily: fs, marginTop: '4px' }}>📞 <a href={`tel:${contact.phone}`} style={{ color: C.amber, textDecoration: 'none' }}>{formatPhone(contact.phone)}</a></div>}
          {contact.email && <div style={{ fontSize: '12px', color: C.muted, fontFamily: fs, marginTop: '2px' }}>✉ {contact.email}</div>}
          {contact.notes && <div style={{ fontSize: '12px', color: C.muted, fontFamily: fs, marginTop: '4px', fontStyle: 'italic' }}>{contact.notes}</div>}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flexShrink: 0 }}>
          <div style={{ display: 'flex', gap: '4px' }}>
            <button onClick={onMoveUp} disabled={isFirst} style={{ background: 'none', border: `1px solid ${C.border}`, borderRadius: '6px', width: '28px', height: '28px', cursor: isFirst ? 'default' : 'pointer', color: isFirst ? C.border : C.muted, fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>↑</button>
            <button onClick={onMoveDown} disabled={isLast} style={{ background: 'none', border: `1px solid ${C.border}`, borderRadius: '6px', width: '28px', height: '28px', cursor: isLast ? 'default' : 'pointer', color: isLast ? C.border : C.muted, fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>↓</button>
          </div>
          <div style={{ display: 'flex', gap: '4px' }}>
            <button onClick={onEdit} style={{ background: 'none', border: `1px solid ${C.border}`, borderRadius: '6px', width: '28px', height: '28px', cursor: 'pointer', color: C.muted, fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✏</button>
            <button onClick={() => setConfirmDel(true)} style={{ background: 'none', border: `1px solid ${C.danger}44`, borderRadius: '6px', width: '28px', height: '28px', cursor: 'pointer', color: C.danger, fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
          </div>
        </div>
      </div>
      {confirmDel && (
        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: `1px solid ${C.border}`, display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '12px', color: C.danger, fontFamily: fs, flex: 1 }}>Remove this contact?</span>
          <button onClick={() => setConfirmDel(false)} style={{ background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '6px', padding: '4px 10px', fontSize: '12px', color: C.muted, cursor: 'pointer', fontFamily: fs }}>Cancel</button>
          <button onClick={onDelete} style={{ background: C.danger, border: 'none', borderRadius: '6px', padding: '4px 10px', fontSize: '12px', color: '#fff', cursor: 'pointer', fontFamily: fs, fontWeight: '700' }}>Delete</button>
        </div>
      )}
    </div>
  )
}

function ContactForm({ initial, onSave, onCancel }) {
  const [form, setForm] = useState(initial || { name: '', relationship: '', phone: '', email: '', notes: '' })
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }))
  const [saving, setSaving] = useState(false)

  const handleSubmit = async () => {
    if (!form.name.trim()) return
    setSaving(true)
    await onSave(form)
    setSaving(false)
  }

  return (
    <div style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '16px', marginBottom: '12px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
        <div>
          <label style={lbl}>Name *</label>
          <input style={inp} value={form.name} onChange={e => set('name', e.target.value)} placeholder="Full name" autoFocus />
        </div>
        <div>
          <label style={lbl}>Relationship</label>
          <select style={{ ...inp, appearance: 'none', WebkitAppearance: 'none', cursor: 'pointer' }} value={form.relationship} onChange={e => set('relationship', e.target.value)}>
            <option value="">Select...</option>
            {RELATIONSHIPS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>Phone</label>
          <input style={inp} value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(555) 555-5555" type="tel" />
        </div>
        <div>
          <label style={lbl}>Email</label>
          <input style={inp} value={form.email} onChange={e => set('email', e.target.value)} placeholder="name@email.com" type="email" />
        </div>
      </div>
      <label style={lbl}>Notes</label>
      <input style={{ ...inp, marginBottom: '12px' }} value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="e.g. Primary emergency contact, has spare key" />
      <div style={{ display: 'flex', gap: '8px' }}>
        <button onClick={onCancel} style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '8px', padding: '9px', fontSize: '13px', color: C.muted, cursor: 'pointer', fontFamily: fs }}>Cancel</button>
        <button onClick={handleSubmit} disabled={saving || !form.name.trim()} style={{ flex: 2, background: saving || !form.name.trim() ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`, border: 'none', borderRadius: '8px', padding: '9px', fontSize: '13px', color: saving || !form.name.trim() ? C.muted : '#fff', cursor: saving || !form.name.trim() ? 'not-allowed' : 'pointer', fontFamily: fs, fontWeight: '700' }}>
          {saving ? 'Saving...' : 'Save Contact'}
        </button>
      </div>
    </div>
  )
}

const SPECIAL_NEEDS_OPTIONS = [
  { id: 'mobility', label: '♿ Mobility impairment' },
  { id: 'hearing', label: '👂 Hearing impairment' },
  { id: 'vision', label: '👁️ Vision impairment' },
  { id: 'medical_equipment', label: '🏥 Medical equipment (oxygen, etc.)' },
  { id: 'non_english', label: '🌐 Non-English speaking' },
  { id: 'pet_protective', label: '🐕 Pet may be protective of home' },
]

const RELATIONSHIP_OPTIONS = ['Owner', 'Spouse', 'Partner', 'Child', 'Parent', 'Sibling', 'Family', 'Roommate', 'Caretaker', 'Other']
const PET_TYPES = ['Dog', 'Cat', 'Bird', 'Fish', 'Reptile', 'Other']
const MEMBER_SPECIAL_NEEDS = [
  { id: 'mobility', label: '♿ Mobility impairment' },
  { id: 'hearing', label: '👂 Hearing impairment' },
  { id: 'vision', label: '👁️ Vision impairment' },
  { id: 'medical_equipment', label: '🏥 Medical equipment' },
  { id: 'non_english', label: '🌐 Non-English speaking' },
]

function memberEmoji(m) {
  if (m.is_pet) {
    if (m.pet_type === 'Dog') return '🐕'
    if (m.pet_type === 'Cat') return '🐈'
    return '🐾'
  }
  if (m.relationship === 'Child') return '👶'
  if (m.relationship === 'Spouse' || m.relationship === 'Partner') return '👫'
  return '👤'
}

function MemberModal({ initial, onSave, onCancel }) {
  const isPetDefault = initial?.is_pet || false
  const [isPet, setIsPet] = useState(isPetDefault)
  const [form, setForm] = useState({
    name: '', relationship: '', pet_type: '', pet_breed: '',
    special_needs: [], non_english_languages: '', notes: '',
    preferred_hospital: '', preferred_hospital_phone: '', preferred_hospital_notes: '',
    ...initial,
  })
  const [saving, setSaving] = useState(false)
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }))
  const isNonEnglish = (form.special_needs || []).includes('non_english')

  const handleSubmit = async () => {
    if (!form.name.trim()) return
    setSaving(true)
    await onSave({ ...form, is_pet: isPet })
    setSaving(false)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)', zIndex: 1300, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      onClick={onCancel}>
      <div style={{ background: '#FDFAF6', borderRadius: '20px 20px 0 0', padding: '24px 20px 40px', width: '100%', maxWidth: '480px', boxSizing: 'border-box' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontFamily: f, fontSize: '18px', color: '#2C1D14', marginBottom: '4px' }}>{initial ? 'Edit' : 'Add'} {isPet ? 'Pet' : 'Person'}</div>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
          <button onClick={() => setIsPet(false)} style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: !isPet ? '#B8721F' : '#F2EDE4', color: !isPet ? '#fff' : '#9A7B68', cursor: 'pointer', fontSize: '13px', fontFamily: fs }}>Person</button>
          <button onClick={() => setIsPet(true)} style={{ flex: 1, padding: '8px', borderRadius: '8px', border: 'none', background: isPet ? '#B8721F' : '#F2EDE4', color: isPet ? '#fff' : '#9A7B68', cursor: 'pointer', fontSize: '13px', fontFamily: fs }}>Pet</button>
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={lbl}>Name *</label>
          <input style={inp} value={form.name} onChange={e => set('name', e.target.value)} placeholder={isPet ? "Pet's name" : "Full name"} autoFocus />
        </div>
        {isPet ? (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
              <div>
                <label style={lbl}>Type</label>
                <select style={{ ...inp, appearance: 'none' }} value={form.pet_type || ''} onChange={e => set('pet_type', e.target.value)}>
                  <option value="">Select...</option>
                  {PET_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Breed (optional)</label>
                <input style={inp} value={form.pet_breed || ''} onChange={e => set('pet_breed', e.target.value)} placeholder="e.g. Golden Retriever" />
              </div>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Notes</label>
              <input style={inp} value={form.notes || ''} onChange={e => set('notes', e.target.value)} placeholder="e.g. Friendly, may bark" />
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Relationship</label>
              <select style={{ ...inp, appearance: 'none' }} value={form.relationship || ''} onChange={e => set('relationship', e.target.value)}>
                <option value="">Select...</option>
                {RELATIONSHIP_OPTIONS.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <div style={{ fontSize: '10px', color: '#9A7B68', letterSpacing: '1.5px', textTransform: 'uppercase', fontFamily: fs, marginBottom: '8px' }}>Special Considerations</div>
              {MEMBER_SPECIAL_NEEDS.map(item => (
                <label key={item.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0', cursor: 'pointer', fontSize: '13px', color: '#2C1D14', fontFamily: fs }}>
                  <input
                    type="checkbox"
                    checked={(form.special_needs || []).includes(item.id)}
                    onChange={e => {
                      const curr = form.special_needs || []
                      set('special_needs', e.target.checked ? [...curr, item.id] : curr.filter(n => n !== item.id))
                    }}
                    style={{ width: '16px', height: '16px', accentColor: '#B8721F', flexShrink: 0 }}
                  />
                  {item.label}
                </label>
              ))}
              {isNonEnglish && (
                <input
                  style={{ ...inp, marginTop: '6px', marginLeft: '26px', width: 'calc(100% - 26px)' }}
                  value={form.non_english_languages || ''}
                  onChange={e => set('non_english_languages', e.target.value)}
                  placeholder="Languages spoken (e.g. Spanish, Cantonese)"
                />
              )}
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Notes</label>
              <input style={inp} value={form.notes || ''} onChange={e => set('notes', e.target.value)} placeholder="Any notes for first responders" />
            </div>
            <div style={{ marginBottom: '4px' }}>
              <div style={{ fontSize: '10px', color: '#9A7B68', letterSpacing: '1.5px', textTransform: 'uppercase', fontFamily: fs, marginBottom: '8px' }}>Preferred Hospital</div>
              <input style={{ ...inp, marginBottom: '8px' }} value={form.preferred_hospital || ''} onChange={e => set('preferred_hospital', e.target.value)} placeholder="Hospital name" />
              <input style={{ ...inp, marginBottom: '8px' }} value={form.preferred_hospital_phone || ''} onChange={e => set('preferred_hospital_phone', e.target.value)} placeholder="Hospital phone" type="tel" />
              <input style={inp} value={form.preferred_hospital_notes || ''} onChange={e => set('preferred_hospital_notes', e.target.value)} placeholder="Insurance, special instructions, etc." />
            </div>
          </>
        )}
        <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
          <button onClick={onCancel} style={{ flex: 1, background: 'transparent', border: `1px solid #DDD4C6`, borderRadius: '8px', padding: '10px', fontSize: '13px', color: '#9A7B68', cursor: 'pointer', fontFamily: fs }}>Cancel</button>
          <button onClick={handleSubmit} disabled={saving || !form.name.trim()} style={{ flex: 2, background: saving || !form.name.trim() ? '#DDD4C6' : '#B8721F', border: 'none', borderRadius: '8px', padding: '10px', fontSize: '13px', color: saving || !form.name.trim() ? '#9A7B68' : '#fff', cursor: 'pointer', fontFamily: fs, fontWeight: '700' }}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function EmergencyContacts({ homeId, userId, onClose }) {
  const [personal, setPersonal] = useState([])
  const [services, setServices] = useState([])
  const [householdMembers, setHouseholdMembers] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAddForm, setShowAddForm] = useState(false)
  const [editingContact, setEditingContact] = useState(null)
  const [lookingUp, setLookingUp] = useState(false)
  const [lookupMsg, setLookupMsg] = useState('')
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [editingMember, setEditingMember] = useState(null)
  const [editingService, setEditingService] = useState(null)
  const [serviceForm, setServiceForm] = useState({ name: '', phone: '', notes: '' })
  const [generatingPDF, setGeneratingPDF] = useState(false)

  // Tour signal: this contacts flow closed (welcome tour step 5 waits on it).
  useEffect(() => () => { emitTourEvent(TOUR_EVENT_TYPES.EMERGENCY_CONTACT_FLOW_CLOSED, {}) }, [])

  const generateEmergencySheet = async () => {
    setGeneratingPDF(true)
    try {
      const { data, error } = await supabase.functions.invoke('generate-emergency-pdf', {
        body: { home_id: homeId }
      })
      if (error || !data?.html) throw new Error('Failed')
      const win = window.open('', '_blank')
      if (win) {
        win.document.write(data.html)
        win.document.close()
        win.focus()
        setTimeout(() => win.print(), 800)
      }
    } catch {
      alert('Could not generate emergency sheet. Please try again.')
    } finally {
      setGeneratingPDF(false)
    }
  }

  useEffect(() => { load(); loadMembers() }, [homeId])

  const loadMembers = async () => {
    const { data } = await supabase.from('household_members').select('*').eq('home_id', homeId).order('sort_order')
    if (data) setHouseholdMembers(data)
  }

  const saveMember = async (form) => {
    if (editingMember) {
      const { data } = await supabase.from('household_members').update(form).eq('id', editingMember.id).select().single()
      if (data) setHouseholdMembers(prev => prev.map(m => m.id === data.id ? data : m))
    } else {
      const sort_order = householdMembers.length
      const { data } = await supabase.from('household_members').insert({ ...form, home_id: homeId, sort_order }).select().single()
      if (data) setHouseholdMembers(prev => [...prev, data])
    }
    setShowMemberModal(false)
    setEditingMember(null)
  }

  const deleteMember = async (id) => {
    await supabase.from('household_members').delete().eq('id', id)
    setHouseholdMembers(prev => prev.filter(m => m.id !== id))
  }

  const saveServiceEdit = async () => {
    const { data } = await supabase.from('emergency_contacts').update({
      name: serviceForm.name,
      phone: serviceForm.phone,
      notes: serviceForm.notes,
    }).eq('id', editingService.id).select().single()
    if (data) setServices(prev => prev.map(s => s.id === data.id ? data : s))
    setEditingService(null)
  }

  const updateHome = async (field, value) => {
    await supabase.from('homes').update({ [field]: value }).eq('id', homeId)
  }

  const load = async () => {
    setLoading(true)
    const { data } = await supabase
      .from('emergency_contacts')
      .select('*')
      .eq('home_id', homeId)
      .order('priority', { ascending: true })
      .order('created_at', { ascending: true })
    setLoading(false)
    if (!data) return
    setPersonal(data.filter(c => !c.is_local_service))
    setServices(data.filter(c => c.is_local_service))
  }

  const handleAdd = async (form) => {
    const maxPriority = personal.length > 0 ? Math.max(...personal.map(c => c.priority ?? 0)) : -1
    const { data, error } = await supabase.from('emergency_contacts').insert({
      home_id: homeId,
      user_id: userId,
      name: form.name.trim(),
      relationship: form.relationship || null,
      phone: form.phone.trim() || null,
      email: form.email.trim() || null,
      notes: form.notes.trim() || null,
      priority: maxPriority + 1,
      is_local_service: false,
    }).select().single()
    if (!error && data) {
      setPersonal(prev => [...prev, data])
      setShowAddForm(false)
      // Tour signal: an emergency contact was saved (welcome tour step 5 waits on this).
      emitTourEvent(TOUR_EVENT_TYPES.EMERGENCY_CONTACT_SAVED, { contact_id: data.id })
    }
  }

  const handleEdit = async (form) => {
    const { data, error } = await supabase.from('emergency_contacts').update({
      name: form.name.trim(),
      relationship: form.relationship || null,
      phone: form.phone.trim() || null,
      email: form.email.trim() || null,
      notes: form.notes.trim() || null,
    }).eq('id', editingContact.id).select().single()
    if (!error && data) {
      setPersonal(prev => prev.map(c => c.id === data.id ? data : c))
      setEditingContact(null)
    }
  }

  const handleDelete = async (id) => {
    await supabase.from('emergency_contacts').delete().eq('id', id)
    setPersonal(prev => prev.filter(c => c.id !== id))
  }

  const handleMove = async (idx, direction) => {
    const next = [...personal]
    const swapIdx = idx + direction
    if (swapIdx < 0 || swapIdx >= next.length) return
    ;[next[idx], next[swapIdx]] = [next[swapIdx], next[idx]]
    // Reassign priorities
    for (let i = 0; i < next.length; i++) next[i] = { ...next[i], priority: i }
    setPersonal(next)
    // Persist all updated priorities
    await Promise.all(next.map((c, i) =>
      supabase.from('emergency_contacts').update({ priority: i }).eq('id', c.id)
    ))
  }

  const handleLookup = async () => {
    setLookingUp(true)
    setLookupMsg('Looking up local emergency services...')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const resp = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/lookup-emergency-services`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
        },
        body: JSON.stringify({ home_id: homeId }),
      })
      const result = await resp.json()
      if (result.error) {
        setLookupMsg(`Error: ${result.error}`)
      } else {
        setLookupMsg(`Found ${result.saved ?? 0} local service${result.saved !== 1 ? 's' : ''}`)
        await load()
      }
    } catch (e) {
      setLookupMsg('Lookup failed — check connection')
    }
    setLookingUp(false)
    setTimeout(() => setLookupMsg(''), 4000)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: C.bg, zIndex: 1200, display: 'flex', flexDirection: 'column', fontFamily: f }}>

      {/* Header */}
      <div style={{ background: C.card, borderBottom: `1px solid ${C.border}`, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px', flexShrink: 0 }}>
        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 }}>←</button>
        <div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: C.brown }}>Emergency Contacts</div>
          <div style={{ fontSize: '12px', color: C.muted, fontFamily: fs, marginTop: '1px' }}>Personal contacts & local emergency services</div>
        </div>
      </div>

      {/* Scrollable body */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 40px', maxWidth: '560px', width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>

        <button
          onClick={generateEmergencySheet}
          disabled={generatingPDF}
          style={{
            width: '100%', background: '#2C1D14', color: '#FDFAF6', border: 'none',
            borderRadius: 10, padding: '14px 0', fontFamily: f, fontSize: 15,
            cursor: generatingPDF ? 'wait' : 'pointer', marginBottom: 16,
            opacity: generatingPDF ? 0.7 : 1, display: 'flex', alignItems: 'center',
            justifyContent: 'center', gap: 8,
          }}
        >
          {generatingPDF ? 'Generating...' : '🖨️ Download Emergency Sheet'}
        </button>

        {loading ? (
          <div style={{ color: C.muted, fontFamily: fs, fontSize: '13px', padding: '20px 0' }}>Loading...</div>
        ) : (
          <>
            {/* Household Members */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...subHdr, marginBottom: '8px' }}>
              <span>Household Members</span>
              <button onClick={() => { setEditingMember(null); setShowMemberModal(true) }} style={{ background: 'none', border: 'none', color: C.amber, cursor: 'pointer', fontSize: '13px', fontFamily: fs, fontWeight: '600', padding: 0 }}>+ Add member</button>
            </div>

            {householdMembers.length === 0 && (
              <div style={{ background: C.card, border: `1px dashed ${C.border}`, borderRadius: '12px', padding: '20px', textAlign: 'center', marginBottom: '12px' }}>
                <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>No household members added yet.</div>
              </div>
            )}

            {householdMembers.map(member => (
              <div key={member.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '12px 16px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
                    <span style={{ fontSize: '24px', flexShrink: 0 }}>{memberEmoji(member)}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '15px', color: C.brown, fontWeight: '600', fontFamily: f }}>
                        {member.name}
                        {member.is_pet && member.pet_type && <span style={{ fontSize: '12px', color: C.muted, fontWeight: 400, marginLeft: '6px' }}>— {member.pet_type}</span>}
                      </div>
                      <div style={{ fontSize: '12px', color: C.muted, fontFamily: fs }}>
                        {member.is_pet ? member.pet_breed || '' : member.relationship}
                        {member.special_needs?.length > 0 && <span style={{ marginLeft: '6px' }}>· {member.special_needs.join(', ')}</span>}
                        {member.non_english_languages && <span style={{ marginLeft: '6px' }}>· 🌐 {member.non_english_languages}</span>}
                      </div>
                      {!member.is_pet && member.preferred_hospital && (
                        <div style={{ fontSize: '12px', color: C.brown, fontFamily: fs, marginTop: '3px' }}>
                          🏥 {member.preferred_hospital}
                          {member.preferred_hospital_phone && <a href={`tel:${member.preferred_hospital_phone}`} style={{ color: C.amber, textDecoration: 'none', marginLeft: '6px' }}>{formatPhone(member.preferred_hospital_phone)}</a>}
                        </div>
                      )}
                      {!member.is_pet && member.preferred_hospital_notes && (
                        <div style={{ fontSize: '11px', color: C.muted, fontFamily: fs, marginTop: '2px', fontStyle: 'italic' }}>{member.preferred_hospital_notes}</div>
                      )}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexShrink: 0, marginLeft: '8px' }}>
                    <button onClick={() => { setEditingMember(member); setShowMemberModal(true) }} style={{ background: 'none', border: 'none', color: C.amber, cursor: 'pointer', fontSize: '13px', fontFamily: fs }}>Edit</button>
                    <button onClick={() => deleteMember(member.id)} style={{ background: 'none', border: 'none', color: C.muted, cursor: 'pointer', fontSize: '16px' }}>✕</button>
                  </div>
                </div>
              </div>
            ))}

            {/* Preferred hospital summary — amber warning box */}
            {householdMembers.filter(m => !m.is_pet && m.preferred_hospital).length > 0 && (
              <div style={{ background: '#FFF8E7', border: `1px solid ${C.amber}44`, borderRadius: '10px', padding: '12px 14px', marginBottom: '8px' }}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: C.amber, marginBottom: '6px', fontFamily: f }}>🏥 Preferred Hospitals</div>
                {householdMembers.filter(m => !m.is_pet && m.preferred_hospital).map(m => (
                  <div key={m.id} style={{ fontSize: '12px', color: C.brown, fontFamily: fs, marginBottom: '4px' }}>
                    <span style={{ fontWeight: '600' }}>{m.name}</span>
                    {' — '}{m.preferred_hospital}
                    {m.preferred_hospital_phone && <a href={`tel:${m.preferred_hospital_phone}`} style={{ color: C.amber, textDecoration: 'none', marginLeft: '6px' }}>{formatPhone(m.preferred_hospital_phone)}</a>}
                  </div>
                ))}
              </div>
            )}

            <div style={{ height: '8px' }} />

            {/* Personal Contacts */}
            <div style={subHdr}>Personal Contacts</div>

            {personal.length === 0 && !showAddForm && (
              <div style={{ background: C.card, borderRadius: '12px', border: `1px dashed ${C.border}`, padding: '24px', textAlign: 'center', marginBottom: '12px' }}>
                <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>No personal contacts added yet.</div>
              </div>
            )}

            {personal.map((c, i) => (
              editingContact?.id === c.id ? (
                <ContactForm key={c.id} initial={c} onSave={handleEdit} onCancel={() => setEditingContact(null)} />
              ) : (
                <ContactCard
                  key={c.id}
                  contact={c}
                  isFirst={i === 0}
                  isLast={i === personal.length - 1}
                  onEdit={() => setEditingContact(c)}
                  onDelete={() => handleDelete(c.id)}
                  onMoveUp={() => handleMove(i, -1)}
                  onMoveDown={() => handleMove(i, 1)}
                />
              )
            ))}

            {showAddForm ? (
              <ContactForm onSave={handleAdd} onCancel={() => setShowAddForm(false)} />
            ) : (
              <button
                onClick={() => setShowAddForm(true)}
                style={{ width: '100%', background: 'transparent', border: `1px dashed ${C.amber}`, borderRadius: '10px', padding: '12px', fontSize: '13px', color: C.amber, cursor: 'pointer', fontFamily: fs, fontWeight: '600', marginBottom: '4px' }}
              >
                + Add Contact
              </button>
            )}

            {/* Local Emergency Services */}
            <div style={subHdr}>Local Emergency Services</div>

            {/* Always-present 911 card */}
            <div style={{ background: C.danger, borderRadius: '12px', padding: '14px 16px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ fontSize: '28px', flexShrink: 0 }}>🚨</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.7)', letterSpacing: '1px', textTransform: 'uppercase', fontFamily: fs, marginBottom: '2px' }}>Emergency</div>
                <div style={{ fontSize: '22px', fontWeight: '700', color: '#fff', fontFamily: f, lineHeight: 1 }}>911</div>
                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.8)', fontFamily: fs, marginTop: '2px' }}>Police · Fire · Medical</div>
              </div>
              <a href="tel:911" style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', padding: '8px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', fontFamily: fs, textDecoration: 'none' }}>Call</a>
            </div>

            {/* National Poison Control */}
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '12px 16px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ fontSize: '22px', flexShrink: 0 }}>☠️</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '11px', color: C.muted, letterSpacing: '1px', textTransform: 'uppercase', fontFamily: fs, marginBottom: '2px' }}>Poison Control</div>
                <div style={{ fontSize: '14px', fontWeight: '700', color: C.brown, fontFamily: f }}>National Poison Control</div>
                <div style={{ fontSize: '13px', fontFamily: fs, marginTop: '2px' }}>📞 <a href="tel:18002221222" style={{ color: C.amber, textDecoration: 'none' }}>(800) 222-1222</a></div>
              </div>
            </div>

            {services.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {services.map(s => {
                  const cfg = SERVICE_CONFIG[s.service_type] || SERVICE_CONFIG.other
                  const isEditing = editingService?.id === s.id
                  return (
                    <div key={s.id} style={{ background: C.card, border: `1px solid ${isEditing ? C.amber : C.border}`, borderRadius: '12px', padding: '12px 16px' }}>
                      {isEditing ? (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                            <span style={{ fontSize: '18px' }}>{cfg.icon}</span>
                            <span style={{ fontSize: '11px', color: C.muted, textTransform: 'uppercase', letterSpacing: '1px', fontFamily: fs }}>{cfg.label}</span>
                          </div>
                          <input style={{ ...inp, marginBottom: '8px' }} value={serviceForm.name} onChange={e => setServiceForm(p => ({ ...p, name: e.target.value }))} placeholder="Name" />
                          <input style={{ ...inp, marginBottom: '8px' }} value={serviceForm.phone} onChange={e => setServiceForm(p => ({ ...p, phone: e.target.value }))} placeholder="Phone" type="tel" />
                          <input style={{ ...inp, marginBottom: '10px' }} value={serviceForm.notes} onChange={e => setServiceForm(p => ({ ...p, notes: e.target.value }))} placeholder="Notes" />
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button onClick={() => setEditingService(null)} style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '7px', padding: '7px', fontSize: '13px', color: C.muted, cursor: 'pointer', fontFamily: fs }}>Cancel</button>
                            <button onClick={saveServiceEdit} style={{ flex: 2, background: C.amber, border: 'none', borderRadius: '7px', padding: '7px', fontSize: '13px', color: '#fff', cursor: 'pointer', fontFamily: fs, fontWeight: '700' }}>Save</button>
                          </div>
                        </>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ fontSize: '22px', flexShrink: 0 }}>{cfg.icon}</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: '11px', color: C.muted, letterSpacing: '1px', textTransform: 'uppercase', fontFamily: fs, marginBottom: '2px' }}>{cfg.label}</div>
                            <div style={{ fontSize: '14px', fontWeight: '700', color: C.brown, fontFamily: f }}>{s.name}</div>
                            {s.phone && <div style={{ fontSize: '13px', fontFamily: fs, marginTop: '2px' }}>📞 <a href={`tel:${s.phone}`} style={{ color: C.amber, textDecoration: 'none' }}>{formatPhone(s.phone)}</a></div>}
                            {s.notes && <div style={{ fontSize: '12px', color: C.muted, fontFamily: fs, marginTop: '2px' }}>{s.notes}</div>}
                          </div>
                          <button
                            onClick={() => { setEditingService(s); setServiceForm({ name: s.name || '', phone: s.phone || '', notes: s.notes || '' }) }}
                            style={{ background: 'none', border: 'none', color: C.muted, cursor: 'pointer', fontSize: '13px', fontFamily: fs, padding: '4px 6px', flexShrink: 0 }}
                          >✏</button>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}

            {services.length === 0 && !loading && (
              <div style={{ background: C.card, borderRadius: '12px', border: `1px dashed ${C.border}`, padding: '16px', textAlign: 'center', marginBottom: '8px' }}>
                <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>Local services loading… check back shortly.</div>
              </div>
            )}

            <div style={{ marginTop: '12px', textAlign: 'center' }}>
              <button
                onClick={handleLookup}
                disabled={lookingUp}
                style={{ background: 'none', border: 'none', fontSize: '12px', color: lookingUp ? C.border : C.muted, cursor: lookingUp ? 'not-allowed' : 'pointer', fontFamily: fs, padding: '4px 0' }}
              >
                {lookingUp ? 'Refreshing...' : '↻ Refresh local services'}
              </button>
              {lookupMsg && <div style={{ fontSize: '11px', color: C.success, fontFamily: fs, marginTop: '4px' }}>{lookupMsg}</div>}
            </div>
          </>
        )}
      </div>

      {showMemberModal && (
        <MemberModal
          initial={editingMember}
          onSave={saveMember}
          onCancel={() => { setShowMemberModal(false); setEditingMember(null) }}
        />
      )}
    </div>
  )
}
